import * as React from "react"
import * as Conf from "../../../configuration"
import * as CommonUtils from "../../utils"
import { bodyW } from "../../pptx-configuration/constants"
import * as CashFlowDomain from "../../../../../domain/sfp/cash-flow-domain"

export default class DobTable extends React.Component<Props> {
	private readonly LABEL_CELL_WIDTH: number
	private readonly VALUE_CELL_WIDTH: number

	constructor(props: Readonly<Props>) {
		super(props)
        this.LABEL_CELL_WIDTH = CommonUtils.toInches(6.3);
		this.VALUE_CELL_WIDTH = (bodyW - this.LABEL_CELL_WIDTH) / props.years.length;
	}

	render() {
		const tableConf = this.props.tableConfiguration
		
		return<table id={this.props.id}>
				<thead>
					<tr>
						<th data-pptx-width={this.LABEL_CELL_WIDTH}
						style={{ ...tableConf.header }}></th>

						{this.props.years.map((y, yi) =>
							<th data-pptx-width={this.VALUE_CELL_WIDTH}
							key={yi}
							style={{ ...tableConf.header }}>{y}</th>
						)}
					</tr>
				</thead>
				{this.renderDobTBody()}
			</table>
		
	}

	private getDisplayedValue(value: number, type?: RowType,key?:number): React.ReactText {
		const locale = this.props.locale

		if ("duration" === type) {
			return CashFlowDomain.formatDeleveragingYears(value)
		}

		if ("percentage" === type) {
			const formatter = new Intl.NumberFormat(locale, { style: "percent" })
			return formatter.format(value)
		}		

		const currency = this.props.currency
		const roundness = this.props.roundness

		return CommonUtils.formatCurrency(locale, currency, value, roundness)
	}

	private getRowBaseStyle(row: TableRow): React.CSSProperties {
		if (isSubtotalTableRow(row)) return this.props.tableConfiguration.subtotal
		if (isTotalTableRow(row)) return this.props.tableConfiguration.total
		if (isRatioTableRow(row)) return this.props.tableConfiguration.ratio

		return this.props.tableConfiguration.common
	}

	private renderDobTBody(): React.ReactNode {
		const rows: TableRow[] = [
			{
				label: "Objectif CAF",
				values:  this.props.targetCaf
			},
			{
				label: "Remboursement des emprunts",
				values:  this.props.loanRefund
			},
			{
				label: "CAF Nette",
				values:  this.props.cafNette
			},
			{
				label: "Investissements récurrents",
				values: this.props.recurentInvests
			}
			,
			{
				label: "Autofinancement net",
				values: this.props.autofinancingNet
			}
			,
			{
				label: "Taux de désendettement",
				type:"duration",
				values: this.props.deleveragingYear
			}
			,
			{
				label: "Remb. Emprunt/CAF Brute",
				ratio:true,
				type:"percentage",
				values: this.props.loanCafRefund,
			}
			,
			{
				label: "Capital Restant Dû",
				values: this.props.remainingCapital
			}

		]

		return <tbody>
			{rows.map(
			(row, rowIndex) =>
				this.props.enableHideZeroLines ?	CommonUtils.isArrayAllValuesZero(row.values) === false && this.renderRow(row, rowIndex) : this.renderRow(row, rowIndex)
			)}
      	</tbody>
	}

	private renderRow(row: TableRow, key?: number): React.ReactNode {
		const years = this.props.years

		const conf = this.props.tableConfiguration
		const baseStyle: React.CSSProperties = this.getRowBaseStyle(row)

		return <tr key={key}>
			<td style={{ ...baseStyle }}>{row.label}</td>
			{years.map((_y, yearIndex) => {
				const value = row.values[yearIndex]
				return <td key={yearIndex} style={{ ...baseStyle, ...conf.numeric }}>
					{this.getDisplayedValue(value, row.type,yearIndex)}
				</td>
			})}
		</tr>
	}
}

export interface Props {
	targetCaf:number[];
	loanRefund:number[];
	cafNette:number[];
	recurentInvests:number[];
	autofinancingNet:number[];
	deleveragingYear:number[];
	loanCafRefund:number[];
	remainingCapital:number[];	
	currentYear:number;
    id: string;
    currency: string;
    locale: string;
    roundness: Conf.RoundnessValue
    enableHideZeroLines: boolean;
	tableConfiguration: Conf.TableConfiguration;
	years: number[];
}

function isSubtotalTableRow(row: TableRow): row is SubtotalTableRow {
	return undefined !== (row as SubtotalTableRow).subtotal
}

function isTotalTableRow(row: TableRow): row is TotalTableRow {
	return undefined !== (row as TotalTableRow).total
}

function isRatioTableRow(row: TableRow): row is RatioTableRow {
	return undefined !== (row as RatioTableRow).ratio
}

interface BaseTableRow {
	label: string
	values: number[]
	type?: RowType
}

interface SubtotalTableRow extends BaseTableRow {
	subtotal: boolean
}

interface TotalTableRow extends BaseTableRow {
	total: boolean
}

interface RatioTableRow extends BaseTableRow {
	ratio: boolean
}

interface YearHeader{
	year:number;
	isReal:boolean;
	libelle:string;
}

type RowType = "currency" | "duration" | "percentage"

type TableRow = BaseTableRow | SubtotalTableRow | TotalTableRow | RatioTableRow

export interface ChapterRow{
	chapitreNumber:string;
	chapitreLibelle:string;
	values:number[]
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/dob-generator/dob-table/dob-table.tsx